module.exports = __webpack_public_path__ + "static/media/ic_back.e506b369.svg";